import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    accordion: {
        backgroundColor: "transparent !important",
        boxShadow: "none !important",
        "& > .MuiButtonBase-root": {
            padding: 0,
            minHeight: "unset !important",
        },
    },
    accordionSummary: {
        "& > .MuiAccordionSummary-content": {
            margin: "0 !important",
            minHeight: "unset",
        },
    },
    accordionDetails: {
        display: "flex",
        flexFlow: "column nowrap",
        backgroundColor: "rgba(0,0,0,0.10)",
        padding: "5px 0",
    },
    menuClose: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 32,
        height: 32,
        borderRadius: "4px",
        cursor: "pointer",
        color: theme.palette.primary.contrastText,
        "&:hover": {
            background: "rgba(255, 255, 255, .10)",
            fill: theme.palette.common.white,
            color: theme.palette.common.white,
        },
    },
}); });
